import { Component, EventEmitter, Input, Output, Inject, LOCALE_ID, AfterViewInit } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';
import { InitialDataService } from 'src/app/services/page/initial-data.service';
import { take, takeUntil } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { Router } from '@angular/router';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { gameTrx, liveCasinoTrx, loginTrx, signUpTrx, slotsLuckeraTrx, referFriendTrx } from 'src/app/router-translation.labels';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { UserMessagesService } from 'src/app/services/user-messages/user-messages.service';
import { Language, MenuItem } from 'src/app/apollo/models/base-models';
import { CookieService } from 'ngx-cookie-service';
import { HOST_NAME } from 'src/app/global.tokens';
import { UploadDocumentsService } from 'src/app/services/profile/upload-documents.service';
import { sectionsData, DocumentData, UserDocumentsResponse, SectionCard, Status } from 'src/app/services/profile/upload-documents.models';
import { PendingWithdrawalService } from 'src/app/services/payment/withdrawal/pending-withdrawal.service';
import { PendingWithdrawalList } from 'src/app/services/payment/withdrawal/withdrawal.models';
import { PendingRewardsService } from 'src/app/services/prizes/pending-rewards.service';
import { PendingReward } from 'src/app/services/prizes/prizes.models';
import { extractLanguageCode } from 'src/app/utils/language-switch.utils';
import { InstallPromptService, isAppMenuItem } from 'src/app/services/pwa/install-prompt.service';



@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent extends BasePageComponent implements AfterViewInit {


  liveCasinoRoute: string = `/${this.translationConfig.getTranslation(liveCasinoTrx)}`;
  slot: string = `/${this.translationConfig.getTranslation(slotsLuckeraTrx)}`;
  selectedLanguage: Language;

  constructor(
    public initialData: InitialDataService,
    private router: Router,
    protected loginStatus: LoginStatusService,
    public detectDeviceService: DetectDeviceService,
    protected translationConfig: TranslationConfig,
    protected licenceService: LicenceService,
    private userMessagesService: UserMessagesService,
    private documentService: UploadDocumentsService,
    private pendingListService: PendingWithdrawalService,
    private cookie: CookieService,
    private pendinRewardsService: PendingRewardsService,
    @Inject(HOST_NAME) public hostName,

    @Inject(LOCALE_ID) public locale,
    private installPromptService: InstallPromptService,

  ) { super() }
  isLogin: boolean = false;
  _isVisible: boolean = false;
  unreadMessages: number = 0;
  public userDocumentData: SectionCard[];
  hasDocumentRequest: boolean;
  pendingList: PendingWithdrawalList;
  pendingRewardsList:PendingReward[]


  @Input() set isVisible(value: boolean) {
    this._isVisible = value;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  childData: any;
  allMenuItems: any[] = [];
  deferredPrompt: any;

  ngOnInit(): void {
    this.installPromptService.deferredPrompt$.pipe(takeUntil(this.unsubscribe)).subscribe(prompt => {
      this.deferredPrompt = prompt;
      if (this.childData?.topMenuItems) {
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...this.childData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
      }
    });


    const set_sidenav = (api_call$) => {
      api_call$.pipe(takeUntil(this.unsubscribe)).subscribe(([resp, canRefer]) => {
        const viewData = { ...resp };

        if (!canRefer) {
          const referFriendPath = this.translationConfig.getTranslation(referFriendTrx);
          viewData.topMenuItems = (viewData.topMenuItems as MenuItem[]).filter((item: MenuItem) =>
            !(item.inAppUrl?.toLowerCase() || '').includes(referFriendPath)
          );
        }
        this.allMenuItems = viewData.topMenuItems || [];
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...viewData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };

        this.selectedLanguage = resp.languages.find(item => {
          const parts = item.name.split("-"); // Specific logic for Luckera locale parsing
          const langCode = parts[parts.length - 1].trim();
          return langCode === this.locale;
        });
      });
    }

    this.loginStatus.getLoginPartialStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isLogin = resp;

      if (this.isLogin) {
        this.userMessagesService.unreadMessagesCount.pipe(take(1)).subscribe((unreadCount) => {
          this.unreadMessages = unreadCount;
        });
        this.pendinRewardsService.getPendingRewards().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
          this.pendingRewardsList = resp;
        });
        this.documentService.updateUserDocuments();
        this.documentService.getUserDocuments().pipe(takeUntil(this.unsubscribe)).subscribe((userDocumentsResponse: UserDocumentsResponse) => {
          if (userDocumentsResponse) {
            this.userDocumentData = this.documentService.fillSectionCards(sectionsData, userDocumentsResponse, this.documentService.getSectionsCookie());
            this.hasDocumentRequest = !!this.userDocumentData.find((item) => !(item.status === this.documentService.translateStatus(Status.Approved) || item.status === this.documentService.translateStatus(Status.NotRequired)) && !item.is_hide);
          }
        });

        setTimeout(() => { // Side Nav count notifications api calls here
          this.pendingWithdrawalCheck();
        }, 0);

        set_sidenav(
          combineLatest([
            this.initialData.fetchData(),
            this.loginStatus.canAccessReferFriend()
          ])
        );
        return;
      }

    });

    set_sidenav(
      combineLatest([
        this.initialData.fetchData(),
        of([])
      ])
    );
  }

  languageHref(item: any): string | null {
    return item?.redirectUrl ? item.redirectUrl : null;
  }

  onLanguageClick(event: MouseEvent, item: any): void {
    if (item?.redirectUrl) {
      event.preventDefault();
      window.location.href = item.redirectUrl;
    }
  }

  setCookie($event: any) {
    const langCode = extractLanguageCode($event?.value);
    if (!langCode) {
      return;
    }
    this.cookie.set('language', langCode, 2592000, '/', this.hostName);
    const selected = this.childData?.languages?.find((item) => item?.name === $event?.value);
    if (selected?.redirectUrl) {
      window.location.href = selected.redirectUrl;
    }
  }

  @Output() closeNav = new EventEmitter();

  callLinkClickedParent(): void {
    this.closeNav.next("");
  }

  login() {
    this.router.navigate(['', loginTrx], { state: { redirectTo: this.router.url } });
    this.callLinkClickedParent();
  }

  signup() {
    this.router.navigate(['', this.translationConfig.getTranslation(signUpTrx)]);
    this.callLinkClickedParent();
  }

  pendingWithdrawalCheck() {
    if (this.isLogin) {
      this.pendingListService.getList().subscribe();
      this.pendingListService.pendingWithdrawalsCount$.pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (resp) => {
          this.pendingList = resp;
        },
        error: (error) => {
          console.log(error)
        }
      });
      this.userMessagesService.unreadMessagesCount.pipe(takeUntil(this.unsubscribe)).subscribe((unreadCount) => {
        this.unreadMessages = unreadCount;
      });
    }
  }

  ngAfterViewInit(): void {
    // Side Nav count notifications api calls here
    this.pendingWithdrawalCheck();
  }

  // app menu item is visible only when the browser offers install (deferredPrompt), i.e. app not installed yet
  // safari never fires beforeinstallprompt, so it is shown there unless opened as the installed app
  filterMenuItems(): any[] {
    return this.allMenuItems.filter(menu => !isAppMenuItem(menu));
  }

}
